"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getFragmentOffset_1 = __importDefault(require("./getFragmentOffset"));
const utils_1 = require("../utils");
const getFragmentNode_1 = __importDefault(require("./getFragmentNode"));
function getDomRange(list) {
    const domSelection = window.getSelection();
    if (domSelection == null || domSelection.anchorNode == null) {
        return null;
    }
    const range = domSelection.getRangeAt(0);
    const endContainer = range.endContainer;
    const startContainer = range.startContainer;
    const fragmentOffsetEnd = getFragmentOffset_1.default(list, endContainer) || 0;
    const fragmentOffsetStart = getFragmentOffset_1.default(list, startContainer) || 0;
    const anchorFragmentNode = getFragmentNode_1.default(startContainer);
    const focusFragmentNode = getFragmentNode_1.default(endContainer);
    let { startOffset, endOffset } = range;
    if (anchorFragmentNode != null && focusFragmentNode != null) {
        startOffset = utils_1.getUTF16Length(anchorFragmentNode.innerText.slice(0, startOffset));
        endOffset = utils_1.getUTF16Length(focusFragmentNode.innerText.slice(0, endOffset));
    }
    const direction = anchorFragmentNode != null && getComputedStyle(anchorFragmentNode).direction === 'rtl' ? 'rtl' : 'ltr';
    const start = startOffset + fragmentOffsetStart;
    const end = endOffset + fragmentOffsetEnd;
    return {
        start,
        end,
        collapsed: range.collapsed,
        direction
    };
}
exports.default = getDomRange;
//# sourceMappingURL=getDomRange.js.map